import { render, staticRenderFns } from "./PaymentEfecty.vue?vue&type=template&id=0d910017&"
import script from "./PaymentEfecty.vue?vue&type=script&lang=js&"
export * from "./PaymentEfecty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports